<template>
  <v-container grid-list-md class="pa-0 ma-0">
    <v-flex xs12 v-if="lAction === 'view'">
      <v-layout row wrap>
        <v-flex xs12 mx-auto>
          <v-flex xs12>
            <v-card flat>
              <v-card-title class="px-0 py-0">
                <v-text-field
                class="pt-0"
                append-icon="search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Vendor Supplier Name, Service Capability, etc.':'Search'"
                hide-details
                v-model="searchVendorSupplier"
                outlined
                clearable
                ></v-text-field>
              </v-card-title>
              <v-card-text class="px-0 pt-2">
                <v-data-table
                :headers="vendorSupplierListHeader"
                :items="vendorSupplierList"
                hide-actions
                class="elevation-3"
                :mobile-breakpoint="0"
                fixed-header
                dense
                :search="searchVendorSupplier"
                >
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th style="font-size: 17px; width: 50px; text-align: center">{{headers[0].text}}</th>
                      <th style="font-size: 17px; width: 140px; text-align: left">{{headers[1].text}}</th>
                      <th style="font-size: 17px; width: 120px; text-align: left">{{headers[2].text}}</th>
                      <th style="font-size: 13px; width: 120px; text-align: left">{{headers[3].text}}</th>
                      <th style="font-size: 13px; width: 300px; text-align: left">{{headers[4].text}}</th>
                      <th style="font-size: 13px; width: 120px; text-align: center">{{headers[5].text}}</th>
                    </tr>
                  </thead>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td> {{ props.index + 1 }} </td>
                    <td> {{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }} </td>
                    <td> {{ props.item.contact_name ? props.item.contact_name : '-' }} </td>
                    <td> {{ props.item.contact_phone ? props.item.contact_phone : '-' }} </td>
                    <td> {{ props.item.service_capability ? props.item.service_capability : '-' }} </td>
                    <td> {{ props.item.city ? props.item.city : '-' }} </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // Common Declarations
      lAction: '',
      beingSaved: false,
      prevScr: '',
      handy: handy,
      config: config,
      rules: handy.rules,
      searchVendorSupplier: '',
      vendorSupplierList: [],
      vendorSupplierListHeader: [
        { text: 'SNo', value: '' },
        { text: 'Vendor Supplier Name', value: 'vendorsupplier_name' },
        { text: 'Contact Person', value: 'contact_name' },
        { text: 'Contact Number(s)', value: 'contact_phone' },
        { text: 'Service Capability', value: 'service_capability' },
        { text: 'City', value: 'city' }
      ]
    }
  },
  created () {
    this.lAction = 'view'
    this.loadVendorSupplierListBO()
  },
  methods: {
    // Common methods
    loadVendorSupplierListBO () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getVendorSupplierListForSmWebApp/', qry)
      .then(response => {
        this.vendorSupplierList = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// VendorSupplierBO.vue?c9770bd2